/* MURLTO collection sorting keeps Dawn's native form and AJAX flow. */
document.addEventListener('click', (event) => {
  const option = event.target.closest('.murlto-sort-menu__option');
  if (option) {
    const menu = option.closest('.murlto-sort-menu');
    const select = menu.closest('.select').querySelector('select[name="sort_by"]');
    if (!select) return;
    const value = option.dataset.sortValue;
    menu.querySelector('.murlto-sort-menu__value').textContent = option.textContent.trim();
    menu.querySelectorAll('.murlto-sort-menu__option').forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
    menu.open = false;
    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
    return;
  }
  document.querySelectorAll('.murlto-sort-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.murlto-sort-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
